module.exports = __webpack_public_path__ + "static/img/product2-2.ef75f2b7.png";